module.exports = __webpack_public_path__ + "img/Group 73.04c2bf50.png";